import { Box } from '@mui/material'
import { Seo } from '@/components/common'
import { FaqSection } from '@/components/sections'

/**
 * FAQ Page Component
 * Frequently asked questions and answers
 */
export const FaqPage = () => {
  return (
    <Box>
      <Seo
        title="FAQ"
        description="Answers to frequently asked questions about Leru Systems' website design services, pricing, process, and timelines for plumbing companies."
        path="/faq"
      />
      <FaqSection />
    </Box>
  )
}
